<template>
    <div class="rubric-section-heading">
        <div class="rubric-section-content">
            <div class="title">
                {{ sectionIn.title }}
            </div>
            <div
                class="weight"
                v-if="rubricShowAdvancedOptions">
                <span class="label">{{ $t('rubrics.weight') }}</span
                >{{ sectionIn.weight }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-form-section-heading-component',
    props: {
        sectionIn: Object,
        rubricShowAdvancedOptions: Boolean,
    },
};
</script>

<style scoped lang="scss">
.rubric-section-heading {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    font-size: $base-font-size;
    font-weight: $font-weight-medium;

    .weight {
        font-size: $default-font-size;

        .label {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }
}
</style>
